import { useEffect } from 'react';
import 'react-app-polyfill/stable';
import { Provider, useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'core-js/actual/promise/finally';
import { PersistGate } from 'redux-persist/lib/integration/react';
import '@rsos/capstone/src/overridePublicPath';
import ErrorBoundary from '@rsos/components/capstone/ErrorBoundary';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import Layout from '@rsos/components/capstone/Layout';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import { FlagProvider } from '@rsos/flags';
import useBeforeUnload from '@rsos/utils/useBeforeUnload';
import useBrowserRefresh from '@rsos/utils/useBrowserRefresh';
import { DatasourceManagementRouter } from './pages/DatasourceManagementRouter';
import { DatasourceManagementState } from './state';
import { InitializationState, initialize } from './state/appSlice';
import { store, persistor, DatasourceDispatch } from './state/store';

const App = () => {
  const dispatch = useDispatch<DatasourceDispatch>();

  const { initializing, initialized, initError } = useSelector<
    DatasourceManagementState,
    InitializationState
  >(state => state.appDataSource);
  useEffect(() => {
    dispatch(initialize());
  }, [dispatch]);

  useBrowserRefresh();
  useBeforeUnload();

  if (initError) {
    return <ErrorPage persistor={persistor} />;
  }
  if (initializing) {
    return <AppLoading />;
  }
  if (initialized) {
    return <DatasourceManagementRouter />;
  }
  return <ErrorPage persistor={persistor} />;
};

// These are all the layout and providers for an admin page
const RSOSAdminWrappedApp = () => {
  return (
    <Provider store={store}>
      <FlagProvider>
        <PersistGate loading={'Loading'} persistor={persistor}>
          <BrowserRouter>
            <Layout appPaths={['/admin/keywords']} persistor={persistor}>
              <ErrorBoundary>
                <AppInnerWrapper>
                  <App />
                </AppInnerWrapper>
              </ErrorBoundary>
            </Layout>
          </BrowserRouter>
        </PersistGate>
      </FlagProvider>
    </Provider>
  );
};

export default RSOSAdminWrappedApp;
